(() => {
  const root = document.querySelector('[data-aq-whatsapp]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const links = () => [...document.querySelectorAll('[data-aq-whatsapp-link]')];
  const phone = String(root.dataset.phone || '').replace(/\D/g, '');
  const validPhone = /^\d{7,15}$/.test(phone);
  const includeContext = root.dataset.includeContext === 'true';

  if (!validPhone) {
    root.hidden = true;
    links().forEach((link) => { link.hidden = true; });
    return;
  }

  const clean = (value, limit = 120) => String(value || '')
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, limit);

  const selectedText = (field) => {
    if (!field || !field.value) return '';
    if (field instanceof HTMLSelectElement) return clean(field.selectedOptions?.[0]?.textContent);
    return clean(field.value);
  };

  const checkedValue = (scope, name) => clean(scope?.querySelector(`input[name="${name}"]:checked`)?.value);

  const queryValue = (name) => clean(new URLSearchParams(window.location.search).get(name));

  const humanizeRegion = (value) => clean(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

  const collectContext = () => {
    // Deliberately excludes name, email, phone, free-text message, address and source URL.
    const consultation = document.querySelector('[data-aqm-consultation]');
    const configurator = document.querySelector('aquemoto-configurator');
    const productTitle = clean(document.querySelector('[data-vt-product-title], .product__title h1')?.textContent);
    const consultationWatercraft = selectedText(consultation?.querySelector('[data-aqm-watercraft]'));
    const configuratorWatercraft = clean(configurator?.dataset.watercraft);
    const regionField = consultation?.querySelector('[data-aqm-region]');
    const rawRegion = selectedText(regionField)
      || clean(configurator?.querySelector('[data-aq-region-input]')?.value)
      || queryValue('region');

    return [
      [root.dataset.labelWatercraft, consultationWatercraft || productTitle || configuratorWatercraft || queryValue('watercraft')],
      [root.dataset.labelEdition, selectedText(consultation?.querySelector('[data-aqm-edition]')) || checkedValue(configurator, 'edition') || queryValue('edition')],
      [root.dataset.labelFinish, selectedText(consultation?.querySelector('[data-aqm-finish]')) || checkedValue(configurator, 'finish') || queryValue('finish') || queryValue('color')],
      [root.dataset.labelRegion, regionField?.value ? rawRegion : humanizeRegion(rawRegion)],
      [root.dataset.labelDestination, selectedText(consultation?.querySelector('[data-aqm-destination-country]')) || queryValue('destination_country')],
      [root.dataset.labelExperience, selectedText(consultation?.querySelector('[data-aqm-experience]')) || queryValue('experience')],
      [root.dataset.labelUse, selectedText(consultation?.querySelector('[data-aqm-use]')) || queryValue('use') || queryValue('use_case')],
      [root.dataset.labelQuantity, selectedText(consultation?.querySelector('[data-aqm-quantity]')) || queryValue('quantity')],
      [root.dataset.labelTiming, selectedText(consultation?.querySelector('[data-aqm-timing]')) || queryValue('timing')],
    ].filter(([label, value]) => clean(label) && clean(value) && clean(value) !== '—');
  };

  const buildMessage = () => {
    const base = clean(root.dataset.message, 600);
    if (!includeContext) return base;
    const context = collectContext();
    if (!context.length) return base;
    const heading = clean(root.dataset.contextHeading) || 'Current brief';
    const details = context.map(([label, value]) => `${clean(label)}: ${clean(value)}`);
    return [base, '', heading, ...details].filter(Boolean).join('\n').slice(0, 1400);
  };

  const updateLinks = () => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(buildMessage())}`;
    links().forEach((link) => {
      link.href = url;
      link.hidden = false;
    });
  };

  updateLinks();
  document.body.classList.toggle('aq-whatsapp-has-consultation', Boolean(document.querySelector('[data-aqm-consultation]')));

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-aq-whatsapp-link]')) updateLinks();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-aqm-consultation], aquemoto-configurator')) updateLinks();
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-aqm-destination-country], [data-aqm-quantity]')) updateLinks();
  });
  document.addEventListener('aquemoto:configurationchange', updateLinks);
  document.addEventListener('aquemoto:service-region-change', updateLinks);
  window.addEventListener('popstate', updateLinks);

  document.addEventListener('shopify:section:load', () => {
    document.body.classList.toggle('aq-whatsapp-has-consultation', Boolean(document.querySelector('[data-aqm-consultation]')));
    updateLinks();
  });
})();
